module.exports = __webpack_public_path__ + "img/logo_cua_crest.6708a33c.png";